import React, { useState, useContext } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import Support from '../fragments/Support';
import Petitions from '../fragments/Petitions';
import Principal from '../fragments/Principal';
import HistoryRadio from '../fragments/HistoryRadio';
import RadioPlayer from '../fragments/RadioPlayer';
import Spots from '../fragments/Spots';
import './HomeRadio.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from '../assets/amradio.avif';
import logoPrincipal from '../assets/principal.png';
import logoSpots from '../assets/listadespots.png';
import logoMonitoreo from '../assets/monitoreo.png';
import logoSoporte from '../assets/sopoerte.png';
import logoUsuarios from '../assets/usuarios.png';
import facebookIcon from '../assets/fb.png';
import instagramIcon from '../assets/ig.png';
import tiktokIcon from '../assets/tik.png';
import footprint from '../assets/www.png';
import ConnectedUsers from '../fragments/ConnectedUsers';
import UsersList from '../fragments/UsersList';
import { PresenceContext } from '../App';

const HomeRadio = ({ radio, userLevel }) => {
    const [activeTab, setActiveTab] = useState('Principal');
    const { handleLogout } = useContext(PresenceContext);
    const url = new URL(radio.url_address);
    const lastPartOfPath = url.pathname.substring(url.pathname.lastIndexOf('/') + 1);
    const radioName = lastPartOfPath;

    return (
        <div className="d-flex flex-column">
          {/* Top Bar */}
          <div className="p-3 text-white top-bar">
            <div className="row w-100 align-items-center">
              <div className="col-md-3 col-12 mb-3 mb-md-0">
                <div className="text-center">
                  <img src={logo} alt="Radio Interna" className="responsive-logo" style={{ maxWidth: '20%', height: 'auto', marginTop: '10px' , marginBottom: '10px'}} />
                  <h3 className="mt-2">Escuchas Radio: {radio.title}</h3>
                </div>
              </div>
              <div className="col-md-2 d-none d-md-block"></div>
              <div className="col-md-5 col-12">
                <Navbar variant="dark" className="justify-content-center">
                  <Nav className="flex-row justify-content-around w-100">
                    <Nav.Link 
                      onClick={() => setActiveTab('Principal')}
                      className={`custom-nav-link ${activeTab === 'Principal' ? 'active' : ''}`}>
                      <img src={logoPrincipal} alt="Principal" className="nav-link-img"/>
                    </Nav.Link>
                    <Nav.Link 
                      onClick={() => setActiveTab('Support')}
                      className={`custom-nav-link ${activeTab === 'Support' ? 'active' : ''}`}>
                      <img src={logoSoporte} alt="Soporte" className="nav-link-img" />
                    </Nav.Link>
                    {userLevel < 2 && (
                      <Nav.Link 
                        onClick={() => setActiveTab('Monitoreo')}
                        className={`custom-nav-link ${activeTab === 'Monitoreo' ? 'active' : ''}`}>
                        <img src={logoMonitoreo} alt="Monitoreo" className="nav-link-img" />
                      </Nav.Link>
                    )}
                    {userLevel < 2 && (
                    <Nav.Link 
                      onClick={() => setActiveTab('Spots')}
                      className={`custom-nav-link ${activeTab === 'Spots' ? 'active' : ''}`}>
                      <img src={logoSpots} alt="Spots" className="nav-link-img" />
                    </Nav.Link>
                    )}
                    {userLevel < 2 && (
                    <Nav.Link 
                      onClick={() => setActiveTab('Usuarios')}
                      className={`custom-nav-link ${activeTab === 'Usuarios' ? 'active' : ''}`}>
                      <img src={logoUsuarios} alt="Usuarios" className="nav-link-img"/>
                    </Nav.Link>
                    )}
                  </Nav>
                </Navbar>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="d-flex flex-column flex-md-row flex-grow-1 main-content">
            <div className="sidebar">
              <HistoryRadio radioname={radio.title} serverId={radio.id} />
            </div>
            <div className="right-window">
              {activeTab === 'Principal' && <Principal radioName={radio.title}/>}
              {activeTab === 'Petitions' && <Petitions serverId={radio.id} />}
              {activeTab === 'Spots' && <Spots 
                serverId={radio.id} 
                radioTitle={radio.title}
              />}
              {activeTab === 'Support' && <Support />}
              {activeTab === 'Monitoreo' && <ConnectedUsers radioname={radioName} serverid={radio.id} />}
              {activeTab === 'Usuarios' && <UsersList serverName={radio.url_address} />}
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="d-flex flex-column flex-md-row text-white p-3">
            <div className="radio-player mb-3 mb-md-0">
              <RadioPlayer serverId={radio.id} />
            </div>
            <div className="social-media-container" style={{paddingLeft: '168px'}}>
              {activeTab === 'Principal' && (
                <div className="text-center">
                  <div className="social-icons mb-2">
                    <a href="https://www.facebook.com/amgroupmkt" target="_blank" rel="noopener noreferrer">
                      <img src={facebookIcon} alt="Facebook" style={{ width: '5%', minWidth: '30px' }}/>
                    </a>
                    <a href="https://www.instagram.com/amgroupmkt" target="_blank" rel="noopener noreferrer">
                      <img src={instagramIcon} alt="Instagram" style={{ width: '5%', minWidth: '30px' }}/>
                    </a>
                    <a href="https://www.tiktok.com/@amgroupmkt1" target="_blank" rel="noopener noreferrer">
                      <img src={tiktokIcon} alt="Tiktok" style={{ width: '5%', minWidth: '30px' }}/>
                    </a>
                  </div>
                  <div>
                    <a href="https://www.amgroupmkt.com" target="_blank" rel="noopener noreferrer">
                      <img src={footprint} alt="amgroupmkt" className="footprint-img" style={{ width: '35%', minWidth: '200px' }}/>
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>

          <button 
            onClick={handleLogout} 
            className="logout-btn" 
            title="Cerrar sesión"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M16 17v-3H9v-4h7V7l5 5-5 5M14 2a2 2 0 012 2v2h-2V4H5v16h9v-2h2v2a2 2 0 01-2 2H5a2 2 0 01-2-2V4a2 2 0 012-2h9z"/>
            </svg>
          </button>
        </div>
    );   
};

export default HomeRadio;
